const DarkCursor = () => {
  return (
    <svg
      width="96"
      height="92"
      viewBox="0 0 96 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="95.8548" height="92" rx="46" />
      <path
        d="M24.1779 31.7396L35.2948 67.5609C37.9273 76.0657 49.915 76.1872 52.7296 67.7432L56.01 57.9019C56.9213 55.1683 59.0677 53.0218 61.8014 52.1106L71.6426 48.8302C80.0867 46.0155 79.9449 34.0481 71.4604 31.3954L35.6391 20.2784C28.5923 18.0915 21.9909 24.6928 24.1779 31.7396Z"
        fill="black"
        stroke="black"
        strokeWidth="4.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DarkCursor;
